
// src/components/landing/ZamziVibeSection.tsx
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

const vibeItems = [
    {
        title: "Your Profile, Supercharged",
        description: "Your profile isn't just a page, it's your personal billboard. With built-in SEO, analytics, and profile views, Zamzi Connect makes sure you don't just get seen, you get noticed."
    },
    {
        title: "No More Ghosting",
        description: "We don't just help you promote your business or find a job, we put your name in bright lights, so the right people can finally see what you're made of. No more hiding in the digital shadows like a load shedding schedule!"
    },
    {
        title: "Tata Ma Chance, Tata Ma Change",
        description: "We're as diverse as a Heritage day braai and as driven as your Aunty at a Black Friday sale. Here, businesses get noticed, and job seekers actually get a chance to shine, no 'eish wena' vibes allowed."
    },
    {
        title: "Mama-Approved Network",
        description: "With our sophisticated, custom-engineered AI verification system for ALL Profiles, you're in a network so solid, even your mom would approve. No catfish, no chancers, just real people, real support, and maybe the odd Discord group meme."
    },
    {
        title: "Easy-Peasy, like Cremora",
        description: "If you can find your way through a Joburg traffic circle, you can use Zamzi Connect. Our platform is so easy, even your uncle who still calls it 'the Facebook' will manage."
    },
    {
        title: "More Than just a Platform",
        description: "At Zamzi Connect, we're not just another platform, we're the braai where everyone's invited, the taxi that always has space for one more, and the network where your story finally gets heard. Join us, and let's make South Africa work, one lekker opportunity at a time!"
    }
];

export function ZamziVibeSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold" style={{ color: "#001489" }}>
            The Zamzi Vibe: Built for South Africa, Backed by Tech.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {vibeItems.map((item, index) => (
            <Card key={index} className="shadow-lg border-none overflow-hidden h-full">
              <div style={{ backgroundColor: '#001489'}} className="p-4 h-full flex flex-col">
                <CardHeader className="p-0 mb-3">
                  <CardTitle className="text-lg font-bold text-white">{item.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-0 grow">
                  <p className="text-sm text-white font-bold">{item.description}</p>
                </CardContent>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
